import { Widget } from '@typeform/embed-react';
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';

const BuildMiiTypeForm = (props) => {
    const [uIdToken, setUIdToken] = useState('');
    useEffect(() => {
        setUIdToken(uuidv4());
    },[])

    return (
        <div className="flex flex-col h-full w-full bg-white-900">
            <div className="flex flex-row h-full">
                <div className="flex h-full w-full p-4 text-center">
                    <div className="flex h-full w-full justify-center items-center ">
                        <Widget 
                            id={process.env.REACT_APP_TYPEFORM_FORM_ID} 
                            style={{ width: '85%', height:'80vh' }} 
                            className="buildMii-form" 
                            hidden={{u_id: uIdToken, form_id: process.env.REACT_APP_TYPEFORM_FORM_ID}}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BuildMiiTypeForm